import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import CategoryTypeIndicator from "./CategoryTypeIndicator";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  label: {
    //fontSize: '16px'
  },
  formControl: {
    minWidth: 120
  },
  menuItem: {
    //fontSize: '16px'
  },
  select: {
    //fontSize: '16px'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

class PageCategoryFilter extends React.Component {
  state = {
    selectedFilters: []
  };

  handleChange = event => {
    this.setState({ selectedFilters: event.target.value });
    this.props.onFilterChanged(event.target.value);
  };

  getSelectedFilterColor(name) {
    return this.props.filters.find(f => f.Name === name).Color;
  }

  render() {
    const { classes, filters } = this.props;
    const { selectedFilters } = this.state;

    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="select-multiple-chip">Page type</InputLabel>
          <Select
            multiple
            value={selectedFilters}
            onChange={this.handleChange}
            input={<Input id="select-multiple-chip" />}
            renderValue={selected => (
              <div className={classes.chips}>
                {selected.map(value => (
                  <Chip
                    key={value}
                    label={value}
                    className={classes.chip}
                    avatar={
                      <Avatar style={{ backgroundColor: this.getSelectedFilterColor(value) }} />
                    }>            
                    </Chip>
                ))}
              </div>
            )}
            MenuProps={MenuProps}
          >
            {filters.map(f => (
              <MenuItem key={f.Name} value={f.Name}>
                <Checkbox checked={selectedFilters.indexOf(f.Name) > -1} />
                <ListItemText primary={f.Name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

PageCategoryFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  filters: PropTypes.array
};

export default withStyles(styles, { withTheme: true })(PageCategoryFilter);



// WEBPACK FOOTER //
// ./src/components/PageCategoryFilter.js